import styled from 'styled-components';
import { Button } from '@insurancemenu/imenu-components-lib';

export const DropdownButtonStyled = styled(Button)`
  text-transform: uppercase;
  font-weight: 700;
  height: 3.2rem;
`;

export const DropdownOpenedButtonStyled = styled(Button)`
  text-transform: uppercase;
  height: 3.2rem;
  font-weight: 700;
  font-size: 1.4rem;
`;

export const DropdownOptionTextStyled = styled.span`
  font-size: 1.6rem;
  line-height: 1.8rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
`;
